import { createRoute } from "@tanstack/react-router";
import { VersionMetaPanel } from "@/components/case/version-meta-panel";
import { versionLayoutRoute } from "./version-layout-route";

export const versionMetaRoute = createRoute({
  getParentRoute: () => versionLayoutRoute,
  path: "/meta",
  component: VersionMetaPage,
});

function VersionMetaPage() {
  const { caseId, versionId } = versionMetaRoute.useParams();
  return <VersionMetaPanel caseId={caseId} versionId={versionId} />;
}
